import { StaticDropDownV2 } from '@app/components/generic/generic'

export enum ConfirmationMethod {
  DRAWING = 'drawing',
  AST_02 = 'ast-02',
  AST_03 = 'ast-03',
  AST_04 = 'ast-04',
  AST_07 = 'ast-07',
  CORE_USER = 'core-user',
}
export const CONFIRMATION_METHODS: StaticDropDownV2<ConfirmationMethod>[] = [
  { value: ConfirmationMethod.DRAWING, label_en: 'Signature', label_fr: 'Signature' },
  { value: ConfirmationMethod.AST_02, label_en: 'AST_02', label_fr: 'AST_02' },
  { value: ConfirmationMethod.AST_03, label_en: 'AST_03', label_fr: 'AST_03' },
  { value: ConfirmationMethod.AST_04, label_en: 'AST_04', label_fr: 'AST_04' },
  { value: ConfirmationMethod.AST_07, label_en: 'AST_07', label_fr: 'AST_07' },
  { value: ConfirmationMethod.CORE_USER, label_en: 'Core user', label_fr: 'Utilisateur core' },
]

export enum ConfirmationType {
  ASSET_ASSIGN = 'asset-assign',
  ASSET_UNASSIGN = 'asset-unassign',
  ASSET_TRANSFER_PREMISES = 'asset-transfer-premises',
}
export const CONFIRMATION_TYPES: StaticDropDownV2<ConfirmationType>[] = [
  { value: ConfirmationType.ASSET_ASSIGN, label_en: 'Asset assign', label_fr: 'Assigner un actif' },
  { value: ConfirmationType.ASSET_UNASSIGN, label_en: 'Asset unassign', label_fr: 'Désaffecter un actif' },
  { value: ConfirmationType.ASSET_TRANSFER_PREMISES, label_en: 'Asset transfer premises', label_fr: 'Transférer un actif de bâtiment' },
]

export enum ConfirmationTransition {
  CONFIRM = 'confirm',
  REJECT = 'reject',
}

export enum ConfirmationState {
  WAITING = 'waiting',
  CONFIRMED = 'confirmed',
  REJECTED = 'rejected',
}
export const CONFIRMATION_STATES: StaticDropDownV2<ConfirmationState>[] = [
  { value: ConfirmationState.WAITING, label_en: 'Waiting', label_fr: 'En attente', severity: 'warn' },
  { value: ConfirmationState.CONFIRMED, label_en: 'Confirmed', label_fr: 'Confirmé', severity: 'success' },
  { value: ConfirmationState.REJECTED, label_en: 'Rejected', label_fr: 'Rejeté', severity: 'danger' },
]
